/** Licences: everyone with a licence date, soonest first. Its four counts (#635) sit above it and filter it in place. */
import type { PersonLine, ViewDef } from "../views";

/** "Within 30 days" opens Everyone's Licence expires pick, the same people (`expiringWithin=30`). */
export const WITHIN_30 = "view=all&expiringWithin=30";

export const LICENCES: ViewDef = {
  id: "licences",
  title: "Licences",
  paged: false,
  emails: "segment",
  columns: [
    { key: "standing", label: "Standing", kind: "standing" },
    { key: "county", label: "County" },
    { key: "expires", label: "Expires", kind: "date" },
    { key: "days", label: "Days", kind: "num", relative: true },
  ],
  // Below `sm` the list keeps what it is about: the date, with its days under it.
  compact: [{ key: "expires", label: "Expires", kind: "date", under: "days" }],
  empty: "No licence dates on file.",
  facts: (rows: PersonLine[]) => [[rows.filter((r) => r.tag === "d30").length, "within 30 days", WITHIN_30]],
};
